import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import {
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  CardTitle,
  CardSubtitle
} from "reactstrap"

// availity-reactstrap-validation

// Redux
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import Utils from '../Utility'
import { post, get } from "../../helpers/api_helper";

import avatar from "../../assets/images/companies/img-4.png"
// actions
import { createCompany, companySuccess, companyError, updateCompany } from "../../store/actions";
import { profileSuccess, getProfile } from '../../store/auth/profile/actions';
import AddLeadForm from '../Forms/AddLeadForm';
import Loader from "../../components/Loader";
import UnassignedLeads from './Unassigned';
import AssignedLeads from './assigned';
import ArchivedLeads from './Archived';
import ByProjectLeads from './ByProject';
import Lead from './Lead';
import LeadSingle from './LeadSingle';
import { AvForm } from 'availity-reactstrap-validation'
import AvField from 'availity-reactstrap-validation/lib/AvField';
import Multiselect from 'multiselect-react-dropdown';

const Leads = props => {
  const { user, company } = props;
  const [isAddForm, setIsAddForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState("list");
  const [leadId, setLeadId] = useState(null);
  const [currentLead, setCurrentLead] = useState(null);
  const [projectId, setProjectId] = useState(null);
  const [reload, setReload] = useState(false);

  // filter values
  const [clients, setClients] = useState([]);
  const [projects, setProjects] = useState([]);
  const [moders, setModers] = useState([]);
  const [dealers, setDealers] = useState([]);
  const [statusOptions, setStatusOptions] = useState([{ name: `Open`, id: 'Open' }, { name: `In Process`, id: "In Process" }, { name: 'Closed', id: 'Closed' }, { name: 'Rejected', id: 'Rejected' }]);
  // filter selected values
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedClient, setSelectedClient] = useState([]);
  const [selectedProject, setSelectedProject] = useState([]);
  const [selectedModer, setSelectedModer] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState([]);
  // console.log('props on Leads', props);
  const [filterObj, setFilterObj] = useState(null);
  const [leadType, setLeadType] = useState('moderator');

  useEffect(() => {
    if (props?.location?.pathname) {
      let path = props.location.pathname;
      console.log('path name 1', path.split("/"));
      setProjectId(path.split("/")[3]);
      path = path.split("/")[2];
      console.log('path name 2', path);
      if (path != "list" && path != "lead" && path != "project") {
        setLeadId(path);
        setCurrentTab("single");
      } else {
        if (path == 'project') {
          let proj = [], project = [];
          user?.project?.map((item) => {
            if (item?._id == projectId) {
              proj.push({ name: item?.name, id: item?._id });
              project.push(item?._id);
              setLeadType(item?.assignType);
            }
          });
          setSelectedProject(proj);
          const filterObj = {
            project,
          };
          setFilterObj(filterObj);
        }
        else if (path == 'lead')
          setLeadType('auto')
        else
          setLeadType('moderator');
        setCurrentTab('list');
      }
    }
  }, [props.location, user]);

  useEffect(() => {
    if (user) {
      if (user?.role == 'Admin') {
        setStatusOptions([{ name: `Open`, id: 'Open' }, { name: `In Process`, id: "In Process" }, { name: 'Closed', id: 'Closed' }, { name: 'Rejected', id: 'Rejected' }, { name: 'Archived', id: 'Archived' }]);
      }
      getMetaData();
    }
  }, [user, reload, leadType]);

  const getMetaData = () => {
    let proj = [];
    user?.project?.map((item) => {
      if (leadType == 'moderator') {
        if (item?.assignType == 'moderator') {
          const found = proj.findIndex(x => x.id == item?._id);
          if (found == -1) {
            proj.push({ name: item?.name, id: item?._id });
          }
        }
      } else {
        if (item?.assignType == 'auto') {
          const found = proj.findIndex(x => x.id == item?._id);
          if (found == -1) {
            proj.push({ name: item?.name, id: item?._id });
          }
        }
      }
    });
    setProjects(proj);
    let moder = [];
    user?.moderator?.map((item) => {
      const found = moder.findIndex(x => x.id == item?._id);
      if (found == -1) {
        moder.push({ name: item?.name, id: item?._id });
      }
    });
    setModers(moder);
    let deals = [];
    user?.dealer?.map((item) => {
      const found = deals.findIndex(x => x.id == item?._id);
      if (found == -1) {
        deals.push({ name: item?.name, id: item?._id });
      }
    });
    setDealers(deals);
  }

  const handleChangeInput = (list, to) => {
    switch (to) {
      case 'status':
        setSelectedStatus(list);
        break;
      case 'client':
        setSelectedClient(list);
        break;
      case 'project':
        setSelectedProject(list);
        break;
      case 'moder':
        setSelectedModer(list);
        break;
      case 'dealer':
        setSelectedDealer(list);
        break;
    }

  }

  const handleValidFilter = () => {
    // console.log('on submit filter form', selectedStatus, selectedClient, selectedProject, selectedModer, selectedDealer);
    let status = [];
    selectedStatus.map((item) => {
      status.push(item?.id);
    });
    let client = [];
    selectedClient.map((item) => {
      client.push(item?.id);
    });
    let project = [];
    selectedProject.map((item) => {
      project.push(item?.id);
    });
    let moderator = [];
    selectedModer.map((item) => {
      moderator.push(item?.id);
    });
    let dealer = [];
    selectedDealer.map((item) => {
      dealer.push(item?.id);
    });

    const filterObj = {
      status,
      client,
      project,
      moderator,
      dealer
    };
    setFilterObj(filterObj);
    console.log('filter obj', filterObj);
  }

  const resetFilter = () => {
    setSelectedStatus([]);
    setSelectedClient([]);
    setSelectedProject([]);
    setSelectedModer([]);
    setSelectedDealer([]);
    setFilterObj(null);
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader visible={loading} />
        {/* Render Breadcrumb */}
        <Breadcrumb title={Utils.projectName} breadcrumbItem="Lead" />
        <Row>
          <Col lg="12">
            {props.error && props.error ? (
              <Alert color="danger">{props.error}</Alert>
            ) : null}
            {props.success && props.success ? (
              <Alert color="success">{props.success}</Alert>
            ) : null}
          </Col>
        </Row>
        {isAddForm ?
          <AddLeadForm
            role={"Lead"}
            user={user}
            data={currentLead}
            close={setIsAddForm}
            loading={loading}
            setLoading={setLoading}
            setCurrentUser={setCurrentLead}
            getProfile={props?.getProfile}
          />
          : <Card>
            <CardBody>
              <div className="d-flex" style={{ marginLeft: 'auto', marginBottom: 10 }}>
                <div>
                  <CardTitle className="h4">{props.role}</CardTitle>
                  {currentTab != "single" &&
                    <CardSubtitle className="mb-3">
                      All the <code>Leads</code> can be manage from here!.
                    </CardSubtitle>
                  }
                </div>
                <div className="text-center" style={{ marginLeft: 'auto' }}>
                  {currentTab != "single" ?
                    <Button style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor }} onClick={() => setIsAddForm(true)}>
                      Add
                    </Button>
                    :
                    <Button style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor }} onClick={() => props?.history?.goBack()}>
                      Back
                    </Button>
                  }
                </div>
              </div>
              {currentTab !== 'single' &&
                <Row>
                  <Col lg="12">
                    <div className="d-flex" style={{ marginBottom: 30 }}>
                      <AvForm
                        className="form-horizontal"
                        onValidSubmit={(e, v) => {
                          handleValidFilter(e, v)
                        }}>
                        <div className="d-flex">
                          <div className="form-group" style={{ maxWidth: 200 }}>
                            <Multiselect
                              options={statusOptions}
                              selectedValues={selectedStatus}
                              onSelect={(selectedList, selectedItem) => handleChangeInput(selectedList, 'status')}
                              onRemove={(selectedList, removedItem) => handleChangeInput(selectedList, 'status')}
                              displayValue="name"
                              placeholder={"Select Status"}
                              showCheckbox
                              name="status"
                              value={selectedStatus}
                            />
                          </div>
                          <div className="form-group" style={{ marginLeft: 10, maxWidth: 200 }}>
                            <Multiselect
                              options={clients}
                              selectedValues={selectedClient}
                              onSelect={(selectedList, selectedItem) => handleChangeInput(selectedList, 'client')}
                              onRemove={(selectedList, removedItem) => handleChangeInput(selectedList, 'client')}
                              displayValue="name"
                              placeholder={"Select Client"}
                              showCheckbox
                              name="clientName"
                            />
                          </div>
                          <div className="form-group" style={{ marginLeft: 10, maxWidth: 200 }}>
                            <Multiselect
                              options={projects}
                              selectedValues={selectedProject}
                              onSelect={(selectedList, selectedItem) => handleChangeInput(selectedList, 'project')}
                              onRemove={(selectedList, removedItem) => handleChangeInput(selectedList, 'project')}
                              displayValue="name"
                              placeholder={"Select Project"}
                              showCheckbox
                              name="projectId"
                            />
                          </div>
                          {leadType == 'moderator' &&
                            <div className="form-group" style={{ marginLeft: 10, maxWidth: 200 }}>
                              <Multiselect
                                options={moders}
                                selectedValues={selectedModer}
                                onSelect={(selectedList, selectedItem) => handleChangeInput(selectedList, 'moder')}
                                onRemove={(selectedList, removedItem) => handleChangeInput(selectedList, 'moder')}
                                displayValue="name"
                                placeholder={"Select Moderator"}
                                showCheckbox
                                name="assignToM"
                              />
                            </div>
                          }
                          <div className="form-group" style={{ marginLeft: 10, maxWidth: 200 }}>
                            <Multiselect
                              options={dealers}
                              selectedValues={selectedDealer}
                              onSelect={(selectedList, selectedItem) => handleChangeInput(selectedList, 'dealer')}
                              onRemove={(selectedList, removedItem) => handleChangeInput(selectedList, 'dealer')}
                              displayValue="name"
                              placeholder={"Select Channel Partner"}
                              showCheckbox
                              name="assignToD"
                            />
                          </div>
                          <div style={{ alignSelf: 'center', marginLeft: 10 }}>
                            <Button type="submit" onClick={() => handleValidFilter()} color="primary" style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor }}>
                              Search
                            </Button>
                          </div>
                          <div style={{ alignSelf: 'center', marginLeft: 10 }}>
                            <Button color="primary" onClick={() => resetFilter()} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor }}>
                              Reset
                            </Button>
                          </div>
                        </div>
                      </AvForm>
                      {/* {user?.role != 'Dealer' &&
                        <>
                          {currentTab == 'unassigned' ?
                            <Button style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor, marginLeft: 15, marginRight: 5 }}>Unassigned ({countData?.unassigned})</Button>
                            :
                            <Button style={{ backgroundColor: 'transparent', marginLeft: 15, marginRight: 5 }}
                              onClick={() => props.history.replace("/lead/unassigned")}
                            ><span style={{ color: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor }}>Unassigned ({countData?.unassigned})</span></Button>
                          }
                          {currentTab == 'assigned' ?
                            <Button style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor, marginLeft: 5, marginRight: 5 }}>Assigned ({countData?.assigned})</Button>
                            :
                            <Button style={{ backgroundColor: 'transparent', marginLeft: 5, marginRight: 5 }}
                              onClick={() => props.history.replace("/lead/assigned")}
                            ><span style={{ color: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor }}>Assigned ({countData?.assigned})</span></Button>
                          }
                          {user?.role == 'Admin' &&
                            <>
                              {currentTab == 'archived' ?
                                <Button style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor, marginLeft: 5, marginRight: 5 }}>Archived ({countData?.archived})</Button>
                                :
                                <Button style={{ backgroundColor: 'transparent', marginLeft: 5, marginRight: 5 }}
                                  onClick={() => props.history.replace("/lead/archived")}
                                ><span style={{ color: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor }}>Archived ({countData?.archived})</span></Button>
                              }
                            </>
                          }
                          {currentTab == 'project' ?
                            <Button style={{ backgroundColor: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor, marginLeft: 5, marginRight: 5 }}>By Project</Button>
                            :
                            <Button style={{ backgroundColor: 'transparent', marginLeft: 5, marginRight: 5 }}
                              onClick={() => props.history.replace("/lead/project")}
                            ><span style={{ color: props?.user?.company?.theme ? props.user?.company?.theme : Utils.themeColor }}>By Project</span></Button>
                          }
                        </>
                      } */}
                    </div>
                  </Col>
                </Row>
              }
              {currentTab == 'list' &&
                <UnassignedLeads
                  user={user}
                  setIsAddForm={setIsAddForm}
                  setCurrentLead={setCurrentLead}
                  history={props.history}
                  reload={reload}
                  setReload={setReload}
                  setClients={setClients}
                  filterObj={filterObj}
                  leadType={leadType}
                />
              }
              {currentTab == "lead" &&
                <Lead
                  user={user}
                  setIsAddForm={setIsAddForm}
                  setCurrentLead={setCurrentLead}
                  history={props?.history}
                />
              }
              {currentTab == "single" &&
                <LeadSingle
                  user={user}
                  leadId={leadId}
                />
              }
            </CardBody>
          </Card>
        }

      </div>
    </React.Fragment>
  )
}

Leads.propTypes = {
  getProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
  companyError: PropTypes.func,
  companySuccess: PropTypes.func,
  createCompany: PropTypes.func,
  updateCompany: PropTypes.func
}

const mapStatetoProps = state => {
  const { user } = state.Profile;
  const { company } = state.Company;
  return { user, company }
}

export default withRouter(
  connect(mapStatetoProps, { createCompany, companySuccess, companyError, getProfile, updateCompany })(Leads)
)
